import { Controller } from "@hotwired/stimulus"
import renderTemplateHTML from "../src/shared/helpers/render_template_html";

// Connects to data-controller="contact-request"
export default class extends Controller {
  static targets = ['form']
  static outlets = ['modal-dialog']
  static values = { placementNumber: String, catalogCategoryId: String }


  connect() {
    const catalogCategoryDataEl = this.element.closest('[data-catalog-category-id]')
    if (catalogCategoryDataEl && !hasCatalogCategoryIdValue) {
      this.catalogCategoryIdValue = catalogCategoryDataEl.dataset.catalogCategoryId
    }
  }

  openModal() {
    if (!this.hasModalDialogOutlet) {
      const html = this.template({ placementNumber: this.placementNumberValue })

      this.element.insertAdjacentHTML('afterend', html)

      this.loadForm(this.placementNumberValue, this.catalogCategoryIdValue).then((body) => {
        this.updateModalDialogBody(body)
      })
    }

    this.modalDialogOutlet.open()
  }

  updateModalDialogBody(body) {
    this.modalDialogOutlet.updateBody(body);
  }

  loadForm(placementNumber, catalogCategoryId) {
    const url = new URL('/contact_requests/new', window.location.origin)
    if (placementNumber) { url.searchParams.append('placement_number', placementNumber) }
    if (catalogCategoryId) { url.searchParams.append('catalog_category_id', catalogCategoryId) }

    return fetch(url).then((response) => response.text())
  }

  template({ placementNumber }) {
    return `<div id="contact_request_modal_${placementNumber}"
                 data-controller="modal-dialog"
                 data-action="click->modal-dialog#backdropClose">
              <dialog class="modal-dialog" data-modal-dialog-target="dialog">
                <div class="modal-dialog-header" data-modal-dialog-target="header">Запрос обратного звонка</div>
                <div class="modal-dialog-body" data-modal-dialog-target="body">
                  Загрузка...
                </div>
              </dialog>
            </div>`
  }
}
